import { Table, TableColumnsType } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRefundedDetailListOrdersTodo, getRefundedItemsTodo, refundOrder } from '../../../api/refunds.api';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import config from '../../../lib/config';
import {
  IGetRefundedDetailOrdersTodo,
  IGetRefundedItemsTodo,
  IRefundedDetailOrderTodo,
  IRefundedOrderTodo,
} from '../../../models/refunds.model';
import Button from '../../Button';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import Pagination from '../../Pagination';
import ColumnsCollection from './RefundColumns';
import {
  adminRefundCancel,
  adminRefundOrder,
  approvePosPartialRefundTempTodo,
  cancellationOfApprovalPosResult,
  cancelPosResult,
  createPosPartialRefundTempTodo,
  niceRefundOrder,
} from '../../../api/niceRefunds.api';
import { IGetPosResultInfo } from '../../../models/nicePayments.model';
import { getPosResultInfo, postNicePaymentLog } from '../../../api/nicePayments.api';
import PaymentRefundPosProcessModal from './payment/modals/PaymentRefundPosProcessModal';
import useNicePayModule from '../../../hooks/useNicePayModule';
import { IGetPosPartialRefundTempTodo } from '../../../models/niceRefund.model';
import PaymentPartialRefundPosProcessModal from './payment/modals/PaymentPartialRefundPosProcessModal';
import useReceiptPrinterModule from '../../../hooks/useReceiptPrinterModule';
import AdminRefundConfirmModal from './payment/modals/AdminRefundConfirmModal';
import TabItem from '../../class/class/TabItem';
import { getCommonCodeLabel } from '../../../lib/store';
import moment from 'moment/moment';
import ConfirmModal from '../../modals/ConfirmModal';

interface IProps {
  data: IRefundedOrderTodo[] | undefined;
  doGetRefundedOrdersTodo: () => void;
  memberCode?: string;
}

const RefundTarget: FC<IProps> = ({
                                    data,
                                    doGetRefundedOrdersTodo,
                                    memberCode,
                                  }) => {
  const { t } = useTranslation();
  const [Columns1, Columns2] = ColumnsCollection();
  const { successNotification, errorNotification } = useNotification();
  const {
    execute: nicePosExecute1,
    error: niceError1,
    data: nicePosRes1,
    isLoading: nicePosIsLoading1,
  } = useNicePayModule();
  const {
    execute: nicePosExecute2,
    error: niceError2,
    data: nicePosRes2,
    isLoading: nicePosIsLoading2,
  } = useNicePayModule();
  const {
    execute: nicePosExecute3,
    error: niceError3,
    data: nicePosRes3,
    isLoading: nicePosIsLoading3,
  } = useNicePayModule();
  const { execute: niceLogExecute } = useAxios();
  const {
    data: posInfoRes,
    isLoading: posInfoResIsLoading,
    error: posInfoResError,
    execute: posInfoResExecute,
  } = useAxios<IGetPosResultInfo>();

  const {
    data: posInfoRes2,
    isLoading: posInfoResIsLoading2,
    error: posInfoResError2,
    execute: posInfoResExecute2,
  } = useAxios<IGetPosResultInfo>();

  const {
    data: getPartialRefundRes,
    isLoading: getPartialRefundIsLoading,
    error: getPartialRefundError,
    execute: getPartialRefundExecute,
  } = useAxios<IGetPosPartialRefundTempTodo>();
  const {
    data: posRefundRes1,
    isLoading: posRefundIsLoading1,
    error: posRefundError1,
    execute: posRefundExecute1,
  } = useAxios();

  const { data: res, isLoading, error, execute } = useAxios<IGetRefundedItemsTodo>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  const {
    data: adminSubmitRes,
    isLoading: adminSubmitIsLoading,
    error: adminSubmitError,
    execute: adminSubmitExecute,
  } = useAxios();
  const {
    data: submitCancelRes,
    isLoading: submitCancelLoading,
    error: submitCancelError,
    execute: submitCancelExecute,
  } = useAxios();

  const {
    data: niceDetailListRes,
    isLoading: niceDetailListLoading,
    error: niceDetailListError,
    execute: niceDetailListExecute,
  } = useAxios<IGetRefundedDetailOrdersTodo>();


  const [page, setPage] = useState(1);
  const [refundNo, setRefundNo] = useState<number>();
  const [refundVisible, setRefundVisible] = useState(false);
  const [refundCancelVisible, setRefundCancelVisible] = useState(false);
  const [adminRefundVisible, setAdminRefundVisible] = useState(false);
  const [partialRefundVisible, setPartialRefundVisible] = useState(false);
  const [posRefundStep, setPosRefundStep] = useState<'REFUND' | 'COMPLETE' | 'CANCEL'>('REFUND');
  const [posPartialRefundStep, setPosPartialRefundStep] = useState<'FIRST' | 'FIRST-FAIL' | 'SECOND' | 'SECOND-FAIL' | 'THIRD' | 'THIRD-FAIL' | 'COMPLETE' | 'CANCEL'>('FIRST');
  const [tab, setTab] = useState<string>('NICE');

  useEffect(() => {
    doGetRefundedDetailListOrdersTodo();
  }, []);

  useEffect(() => {
    if (refundNo) {
      execute(getRefundedItemsTodo(refundNo));
    }
  }, [refundNo]);

  useEffect(() => {
    if (res?.data[0] && tab === 'NICE' && !adminRefundVisible && !refundCancelVisible) {
      onSubmit();
    }
  }, [res]);

  useEffect(() => {
    if (submitRes) {
      doGetRefundedOrdersTodo();
      doGetRefundedDetailListOrdersTodo();
      setRefundNo(undefined);
      successNotification(t('student.student.message43'));

      setPosRefundStep('COMPLETE');
      setPosPartialRefundStep('COMPLETE');
    }
  }, [submitRes]);

  const doGetRefundedDetailListOrdersTodo = () => {
    if (memberCode) {
      niceDetailListExecute(getRefundedDetailListOrdersTodo(memberCode));
    }
  };

  // ----------- [ Admin Refund Flow ] -----------------


  useEffect(() => {
    if (adminSubmitRes) {
      doGetRefundedOrdersTodo();
      doGetRefundedDetailListOrdersTodo();
      setRefundNo(undefined);
      successNotification(t('student.student.message43'));
    }
  }, [adminSubmitRes]);

  const adminSubmit = (reasonCode: string) => {
    if (refundNo && reasonCode) {
      adminSubmitExecute(adminRefundOrder(refundNo, reasonCode));
    }
  };

  // ----------- [ POS FLOW START ] ------------------

  // 부분결제인 경우 새로운 Payment 기반으로 POS 발송
  const handleApprovePosPartialRefundProcessing = async () => {
    if (getPartialRefundRes?.data) {
      setPosPartialRefundStep('FIRST');

      const paymentRecordCode = getPartialRefundRes?.data.paymentRecordCode;
      const totalPrice = getPartialRefundRes?.data.totalAmount;
      const installmentMonths = getPartialRefundRes?.data.allotmentMm;
      const taxAmt = getPartialRefundRes?.data.vatAmount;
      const catId = posInfoRes?.data.catId;

      try {
        await nicePosExecute1('approve', paymentRecordCode, totalPrice, installmentMonths, taxAmt, '', '', catId);
      } catch (err) {
        setPosPartialRefundStep('CANCEL');
      }
    }
  };

  // 부분결제인 경우 POS 성공시 서버 요청으로 Payment 상태 업데이트
  const handleApprovePosPartialRefundCompleteProcessing = () => {
    if (nicePosRes1?.success && getPartialRefundRes?.data?.paymentRecordCode) {
      const req = { ...nicePosRes1, tamt: nicePosRes1.totalAmount, oid: getPartialRefundRes.data.paymentRecordCode };
      posRefundExecute1(approvePosPartialRefundTempTodo(req));
    }
  };

  // 전체 환불 POS 프로세스 진행
  const handleNicePosRefundProcessing = async (isRestart: boolean = false) => {
    if (getPartialRefundRes?.data?.paymentRecordCode && !isRestart) {
      // await printReceipt(getPartialRefundRes.data.paymentRecordCode);
    }

    if (posInfoRes?.data) {
      setPosRefundStep('REFUND');
      setPosPartialRefundStep('SECOND');

      const refund = data?.find(it => it.refundNo === refundNo)!;

      const paymentRecordCode = refund?.paymentRecordCode;
      const totalPrice = posInfoRes?.data.totalAmount;
      const installmentMonths = posInfoRes?.data.installmentMonths;
      const taxAmt = posInfoRes?.data.vatAmount;
      const approvalNumber = posInfoRes?.data.approvalNumber;
      const transactionDate = posInfoRes?.data.transactionDate;
      const catId = posInfoRes?.data.catId;

      try {
        await nicePosExecute2('cancel', paymentRecordCode, Number.parseInt(totalPrice), installmentMonths, Number.parseInt(taxAmt), approvalNumber, transactionDate, catId);
      } catch (err) {
        setPosRefundStep('CANCEL');
        setPosPartialRefundStep('SECOND-FAIL');
      }
    }
  };

  // 환불 성공 후 결과 전달
  const handleCancelPosResult = () => {
    if (nicePosRes2?.success && refundNo) {
      const req = { ...nicePosRes2, tamt: nicePosRes2.totalAmount };
      submitExecute(cancelPosResult(req, refundNo));
    }
  };

  // 환불 실패 후 기존 승인건 정보 조회
  const handleNiceRefundFlowResetProcessing = () => {
    if (getPartialRefundRes?.data?.paymentRecordCode) {
      posInfoResExecute2(getPosResultInfo(getPartialRefundRes?.data?.paymentRecordCode));
    }
  };

  // 기존 승인건 환불 진행
  const handleNicePosResetRefundProcessing = async () => {
    if (posInfoRes2?.data && getPartialRefundRes?.data) {
      const paymentRecordCode = getPartialRefundRes?.data.paymentRecordCode;
      const totalPrice = posInfoRes2?.data.totalAmount;
      const installmentMonths = posInfoRes2?.data.installmentMonths;
      const taxAmt = posInfoRes2?.data.vatAmount;
      const approvalNumber = posInfoRes2?.data.approvalNumber;
      const transactionDate = posInfoRes2?.data.transactionDate;
      const catId = posInfoRes2?.data.catId;

      setPosPartialRefundStep('THIRD');

      try {
        await nicePosExecute3('cancel', paymentRecordCode, Number.parseInt(totalPrice), installmentMonths, Number.parseInt(taxAmt), approvalNumber, transactionDate, catId);
      } catch (err) {
        setPosPartialRefundStep('THIRD-FAIL');
      }
    }
  };

  const handleNicePosApprovalCancel = () => {
    if (nicePosRes3?.success && getPartialRefundRes?.data?.paymentRecordCode) {
      const req = { ...nicePosRes3, tamt: nicePosRes3.totalAmount, oid: getPartialRefundRes.data.paymentRecordCode };
      execute(cancellationOfApprovalPosResult(req));
      setPosPartialRefundStep('CANCEL');
    }
  };


  // 첫 시나리오
  // 부분 환불인 경우 부분 환불 프로세스 처리
  // 전체 환불인 경우 전체 환불 프로세스 처리
  useEffect(() => {
    const refund = data?.filter(it => it.refundNo === refundNo)[0];
    const refundItem = res?.data[0];

    if (posInfoRes?.data && refund?.refundAmount && refundItem) {
      const totalAmount = Number.parseInt(posInfoRes.data.totalAmount);

      const isPartialRefund = totalAmount - refundItem.paymentCompleteAmount > 0;

      if (isPartialRefund) {
        // 부분 환불 시나리오
        setPartialRefundVisible(true);
        getPartialRefundExecute(createPosPartialRefundTempTodo(refundNo!));
      } else {
        // 전체 환불 시나리오
        setRefundVisible(true);
        handleNicePosRefundProcessing();
      }
    }
  }, [posInfoRes]);

  useEffect(handleApprovePosPartialRefundCompleteProcessing, [nicePosRes1]);

  useEffect(() => {
    handleNicePosRefundProcessing();
  }, [posRefundRes1]);

  useEffect(handleCancelPosResult, [nicePosRes2]);

  useEffect(() => {
    if (!getPartialRefundRes || !getPartialRefundRes.data) return;
    // 이미 처리된 상태면 중복 호출 방지
    if (posPartialRefundStep !== 'FIRST') return;

    handleApprovePosPartialRefundProcessing();
  }, [getPartialRefundRes]);

  useEffect(() => {
    handleNicePosResetRefundProcessing();
  }, [posInfoRes2]);

  useEffect(handleNicePosApprovalCancel, [nicePosRes3]);

  useEffect(() => {
    if (nicePosRes1 && niceError1 && !nicePosIsLoading1) {
      if(!nicePosRes1.success) {
        console.log('nicePosRes1', nicePosRes1);
        errorNotification(niceError1);
        niceLogExecute(postNicePaymentLog(nicePosRes1));
      }
    }
  }, [nicePosRes1, niceError1, nicePosIsLoading1]);

  useEffect(() => {
    if (nicePosRes2 && niceError2 && !nicePosIsLoading2) {
      if(!nicePosRes2.success) {
        console.log('nicePosRes2', nicePosRes2);
        errorNotification(niceError2);
        niceLogExecute(postNicePaymentLog(nicePosRes2));
      }
    }
  }, [nicePosRes2, niceError2, nicePosIsLoading2]);

  useEffect(() => {
    if (nicePosRes3 && niceError3 && !nicePosIsLoading3) {
      if(!nicePosRes3.success) {
        console.log('nicePosRes3', nicePosRes3);
        errorNotification(niceError3);
        niceLogExecute(postNicePaymentLog(nicePosRes3));
      }
    }
  }, [nicePosRes3, niceError3, nicePosIsLoading3]);


  // ----------- [ POS FLOW END ] ------------------

  const onSubmit = () => {
    if (!refundNo) return;

    setPosPartialRefundStep('FIRST')

    const refund = data?.filter(it => it.refundNo === refundNo)[0];

    if (refund && refund.pgCompany === 'TOSS') {
      submitExecute(refundOrder({ refundNos: [refundNo] }));
    } else if (refund && refund.pgCompany === 'NICE' && refund.paymentMethodDetailCode === '02') {
      submitExecute(niceRefundOrder(refundNo));
    } else if (refund && refund.pgCompany === 'NICE' && refund.paymentMethodDetailCode === '01') {
      posInfoResExecute(getPosResultInfo(refund.paymentRecordCode));
    }
  };

  const isPaymentDttmWithin90Days = (paymentDttm: string): boolean => {
    if (!paymentDttm) return false; // 없을 경우만 false

    const firstRegDate = new Date(paymentDttm); // 등록 날짜
    const today = new Date(); // 현재 날짜
    const diffTime = today.getTime() - firstRegDate.getTime(); // 밀리초 차이
    const diffDays = diffTime / (1000 * 60 * 60 * 24); // 일 단위 변환

    return diffDays <= 90; // ✅ 90일 이내면 true
  };


  const doCancelAdminRefund = () => {
    if (refundNo) {
      submitCancelExecute(adminRefundCancel(refundNo));
      setRefundCancelVisible(false);
    }
  };

  useEffect(() => {
    if (submitCancelRes) {
      alert('제외되었습니다.');
      doGetRefundedOrdersTodo();
      doGetRefundedDetailListOrdersTodo();
      setRefundNo(undefined);
    }
  }, [submitCancelRes]);

  useEffect(() => {
    setRefundNo(undefined);
  }, [tab]);

  const tabs = [
    {
      menu: 'NICE',
      menus: 'NICE',
      text: 'NICE',
    },
    {
      menu: 'TOSS',
      menus: 'TOSS',
      text: 'TOSS',
    },
  ];

  const NiceColumns: TableColumnsType<IRefundedDetailOrderTodo> = [
    {
      title: t('student.student.column22'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
      sorter: (a, b) => a.semesterName.localeCompare(b.semesterName),
    },
    {
      title: t('student.student.column48'),
      dataIndex: 'monthNameCode',
      key: 'monthNameCode',
      align: 'center',
      sorter: (a, b) => a.monthNameCode.localeCompare(b.monthNameCode),
      render: (value: string) => getCommonCodeLabel('SY0009', value?.trim() || '', 'ko'),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
      sorter: (a, b) => a.className.localeCompare(b.className),
    },
    {
      title: t('student.student.column107'),
      dataIndex: 'paymentTargetCode',
      key: 'paymentTargetCode',
      align: 'center',
      sorter: (a, b) => a.paymentTargetCode.localeCompare(b.paymentTargetCode),
      render: (value: string) => getCommonCodeLabel('PA0001', value, 'ko'),
    },
    {
      title: t('student.student.column105'),
      dataIndex: 'refundAmount',
      key: 'refundAmount',
      align: 'center',
      sorter: (a, b) => a.refundAmount - b.refundAmount,
      render: value => value?.toLocaleString(),
    },
    {
      title: t('student.student.column106'),
      dataIndex: 'calculateReasonCode',
      key: 'calculateReasonCode',
      align: 'center',
      sorter: (a, b) => a.calculateReasonCode.localeCompare(b.calculateReasonCode),
      render: value => getCommonCodeLabel('PA0008', value, 'ko'),
    },
    {
      title: t('결제 일시'),
      dataIndex: 'paymentDttm',
      key: 'paymentDttm',
      align: 'center',
      sorter: (a, b) => a.paymentDttm.localeCompare(b.paymentDttm),
      render: value => moment(value).format('YYYY.MM.DD HH:mm:ss'),
    },
    {
      title: t('환불 요청 일시'),
      dataIndex: 'firstRegDttm',
      key: 'firstRegDttm',
      align: 'center',
      sorter: (a, b) => a.firstRegDttm.localeCompare(b.firstRegDttm),
      render: value => moment(value).format('YYYY.MM.DD HH:mm:ss'),
    },
    {
      title: t('결제 카드 정보'),
      key: 'cardType',
      align: 'center',
      render: (_, record, index) => (<>
        {record.cardType} <br />
        {record.cardNumber}
      </>),
    },
    {
      title: t('환불 가능 여부'),
      key: 'refundPSBYn',
      align: 'center',
      render: (_, record, index) => isPaymentDttmWithin90Days(record.paymentDttm) ? 'Y' : 'N',
    },
    {
      title: t('student.student.column44'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      sorter: (a, b) => a.memberName.localeCompare(b.memberName),
    },
    {
      title: t('환불 대상제외'),
      key: 'refundCancel',
      align: 'center',
      render: (_, record, index) => (<div className="comm-btn__area mt-2 justify-content-end">
        <button type="button"
                className="btn-basic pink-line small"
                onClick={() => {
                  setRefundNo(record.refundNo);
                  setRefundCancelVisible(true);
                }}
        >
          삭제
        </button>
      </div>),
    },
    {
      title: t('환불'),
      key: 'refund',
      align: 'center',
      render: (_, record, index) => (<div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            onClick={() => {
              setRefundNo(record.refundNo);
              setAdminRefundVisible(true);
            }}
            className="btn-basic pink small"
            text={t('관리자 환불')}
            disabled={record.paymentMethodDetailCode === '03'}
          />

          {isPaymentDttmWithin90Days(record.paymentDttm) && (
            <Button
              onClick={() => {
                setRefundNo(undefined); // 먼저 undefined로 바꿔서 상태 변화 발생
                setTimeout(() => {
                  setRefundNo(record.refundNo);
                }, 0); // 다음 tick에 다시 설정
              }}
              className="btn-basic pink small"
              text={t('student.student.button21')}
              disabled={record.paymentMethodDetailCode === '03'}
            />
          )}
        </div>
      </div>),
    },
  ];

  return (
    <>
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />

      <div className="comm-tab__line">
        <ul>
          {tabs.map(tabItem => (
            <TabItem
              tab={tab}
              setTab={setTab}
              menu={tabItem.menu}
              menus={tabItem.menus}
              text={tabItem.text}
            />
          ))}
        </ul>
      </div>

      {tab === 'NICE' && (
        <>
          <Table
            className="comm-table__area scrollbar"
            columns={NiceColumns}
            dataSource={niceDetailListRes?.data || []}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            rowKey="refundNo"
          />

          <div className="comm-bx__between">
            <div className="common-paging center">
              <Pagination
                count={data?.length || 0}
                page={page}
                setPage={setPage}
              />
            </div>
          </div>
        </>
      )}

      {tab === 'TOSS' && (
        <>
          <Table
            className="comm-table__area"
            columns={Columns1}
            dataSource={data?.filter(it => it.pgCompany === 'TOSS')}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            onRow={record => ({
              onClick: () => setRefundNo(record.refundNo),
            })}
            rowClassName={(record: IRefundedOrderTodo) => {
              return record.refundNo === refundNo ? 'chosen' : 'pointer';
            }}
            rowKey="refundNo"
          />
          <div className="comm-bx__between">
            <div className="common-paging center">
              <Pagination
                count={data?.length || 0}
                page={page}
                setPage={setPage}
              />
            </div>
          </div>
          {refundNo && (
            <>
              <Table
                className="comm-table__area"
                columns={Columns2}
                dataSource={res?.data}
                pagination={{
                  current: 1,
                  pageSize: 99999,
                }}
              />
              <div className="comm-bx__space">
                <div className="comm-btn__area right">
                  <Button
                    onClick={() => setAdminRefundVisible(true)}
                    className="btn-basic pink"
                    text={t('관리자 환불')}
                  />

                  <Button
                    onClick={onSubmit}
                    className="btn-basic pink"
                    text={t('student.student.button21')}
                  />

                </div>
              </div>
            </>
          )}
        </>
      )}

      {refundCancelVisible && (
        <ConfirmModal
          visible={refundCancelVisible}
          setVisible={setRefundCancelVisible}
          onConfirm={doCancelAdminRefund}
          titleText={t('환불 삭제')}
          messageText={t('환불 대상에서 제외하시겠습니까?')}
          cancelText={t('common.button.cancel')}
          confirmText={t('common.button.confirm')}
        />
      )}

      {adminRefundVisible && (
        <AdminRefundConfirmModal
          visible={adminRefundVisible}
          onCancel={() => setAdminRefundVisible(false)}
          onSubmit={adminSubmit}
        />
      )}

      {refundVisible && (
        <PaymentRefundPosProcessModal
          visible={refundVisible}
          step={posRefundStep}
          onCancel={() => {
            setPartialRefundVisible(false);
            setRefundVisible(false);
          }}
        />
      )}

      {partialRefundVisible && (
        <PaymentPartialRefundPosProcessModal
          visible={partialRefundVisible}
          step={posPartialRefundStep}
          onCancel={() => {
            setPartialRefundVisible(false);
            setRefundVisible(false);
          }}
          onReStart={() => {
            handleNicePosRefundProcessing(true);
          }}
          onReset={handleNiceRefundFlowResetProcessing}
        />
      )}
    </>
  );
};

export default RefundTarget;
